var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitsWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 380.721 380.721",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M355.625,93.925c-5.484,0-42.385,0-89.626,0V55.212c0-7.14-5.787-12.908-12.897-12.908H131.918 c-7.128,0-12.908,5.769-12.908,12.908v38.713c-49.983,0-89.423,0-94.646,0C9.318,93.925,0,101.814,0,113.282 c0,11.473,0,22.941,0,22.941h380.721c0,0,0-10.044,0-21.14C380.721,103.97,372.124,93.925,355.625,93.925z M240.181,93.925 c-30.87,0-64.228,0-95.354,0V68.108h95.354V93.925z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.441,321.222c0,10.038,4.996,17.195,17.201,17.195h343.419c12.188,0,17.207-9.853,17.207-17.195V149.857 c-27.245,0-348.798,0-377.839,0v171.364H1.441z M190.36,176.923c37.134,0,67.227,30.086,67.227,67.219 c0,37.122-30.093,67.227-67.227,67.227c-37.133,0-67.219-30.104-67.219-67.227C123.141,207.01,153.227,176.923,190.36,176.923z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.954,288.236 204.768,288.236 204.768,258.562 234.454,258.562 234.454,229.725 204.768,229.725  204.768,200.039 175.954,200.039 175.954,229.725 146.256,229.725 146.256,258.562 175.954,258.562  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitsWhiteIcon);
export default __webpack_public_path__ + "static/media/KitsWhiteIcon.dc9f2d57d8a34eee9d862c8824a77e39.svg";
export { ForwardRef as ReactComponent };